import { makeMutationForm } from 'components/makeMutationForm/makeMutationForm';
import { UpdateBusinessUnitMutationVariables } from './UpdateBusinessUnit.generated';
import { validateMutationForm } from 'toolbox';
import { CreateBusinessUnitMutationVariables } from './CreateBusinessUnit.generated';

export const UpdateBusinessUnitForm = makeMutationForm<
  UpdateBusinessUnitMutationVariables
>({
  config: {
    id: {
      type: 'hidden',
    },
    name: {
      type: 'text',
    },
  },
  validate: (values) =>
    validateMutationForm({
      values,
      config: {
        name: ['required'],
      },
    }),
});

export const CreateBusinessUnitForm = makeMutationForm<
  CreateBusinessUnitMutationVariables
>({
  config: {
    name: {
      type: 'text',
    },
    organisation_id: {
      type: 'organisation_id',
    },
  },
  validate: (values) =>
    validateMutationForm({
      values,
      config: {
        name: ['required'],
        organisation_id: ['required'],
      },
    }),
});
